var app = angular.module('AngularAdmin');

app.directive('pdEditableTextField', require('./editableTextField.js'));
app.directive('pdEditableTableCell', require('./editableTableCell.js'));
app.directive('pdTextBlock', require('./textBlock.js'));
app.directive('pdPivotTable', require('./pivotTable.js'));
app.directive('pdReportDateRangePicker', require('./reportDateRangePicker.js'));

app.directive('aDisabled', require("./misc/aDisabled.js"));
app.directive('pdBindHtmlCompile', require("./misc/pdBindHtmlCompile.js"));
app.directive('pdDragula', require("./misc/pdDragula.js"));
app.directive('pdColorPicker', require("./misc/colorPicker.js"));
app.directive('pdDragulaContainer', require("./misc/pdDragulaContainer.js"));
app.directive('plantDetails', require("./plantDetails.js"));

app.directive('pdCalendar', require("./pdCalendar.js"));

app.directive('pdOrderRequestsList', require("./orderRequestsList.js"));

app.directive('pdOrderDatesEditor', require("./orderDatesEditor.js"));
app.directive('pdOrderFeed', require("./orderFeed.js"));
app.directive('pdTryNewApp', require("./tryNewApp.js"));

require('./misc/datePickerToggle.js');
require('./misc/helperDirectives.js');
require('./misc/keyUp.js');
require('./misc/stickyHeaderTable.js');
require('./misc/validatedInput.js');
require('./orderCalendar.js');
require('./orderPlanner.js');
require('./plantConfiguration.js');
require('./plantConfigurationPermission.js');
require('./productionCalendar.js');
require('./customerOrderCalendar.js');

